<nav aria-label="breadcrumb">
    <div class="breadcrumb-container">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a
                    href="javascript:void(0)"
                    (click)="onAllClick()"
                    class="allbreadcrumb1"
                    [ngClass]="{ 'text-green': breadcrumbs.length === 0 }"
                    [attr.id]="'go-topic-breadcrumb-all'"
                    [attr.data-test]="'go-topic-breadcrumb-all'"
                >
                    Home
                </a>
            </li>
            <li *ngFor="let folder of breadcrumbs; let i = index" class="breadcrumb-item">
                <a
                    class="topic-title-text"
                    href="javascript:void(0)"
                    (click)="onBreadcrumbClick(i)"
                    [ngClass]="{ 'text-green': i === breadcrumbs.length - 1 }"
                    [attr.title]="folder?.topicName"
                    [attr.id]="'go-topic-breadcrumb-' + i"
                    [attr.data-test]="'go-topic-breadcrumb-' + i"
                    >{{ folder?.topicName }}</a
                >
            </li>
        </ol>
    </div>
</nav>
